<template>
    <f7-page name="terms" >
        <bc-navbar></bc-navbar>   
        <div style="padding:5%;" > 
            <terms-of-use v-on:goback="back" ></terms-of-use>     
        </div>                    
    </f7-page>    

</template>
<script>
import PrivacyPolicy from '../components/privacy-policy'
import TermsOfUse from '../components/terms-of-use'

export default {
  components: {
    'terms-of-use': TermsOfUse,
    'privacy-policy': PrivacyPolicy
  },
  methods: {
    back: function () {
      this.$f7.mainView.router.back()
    }
  }
}
</script>



// WEBPACK FOOTER //
// terms.vue?ca142662